import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Logo } from "../../components/site/Header";
import { api, errMsg } from "../../lib/api";

export default function AdminLogin() {
  const nav = useNavigate();
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  if (localStorage.getItem("ss_token")) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("ss_token", data.token);
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[var(--cream)] px-5">
      <form onSubmit={submit} className="fade-up w-full max-w-md rounded-3xl border bg-white p-10 shadow-xl" data-testid="admin-login-form">
        <Logo />
        <h1 className="mt-8 flex items-center gap-2 font-display text-2xl font-semibold text-[var(--forest-dark)]"><Lock className="h-5 w-5" /> Masuk Admin</h1>
        <p className="mt-1 text-sm text-[var(--ink)]/60">Kelola konten website Sembada Satwa.</p>
        <div className="mt-8 space-y-5">
          <div>
            <Label htmlFor="username">Username</Label>
            <Input id="username" className="mt-2 h-11" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} required data-testid="login-username-input" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" className="mt-2 h-11" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required data-testid="login-password-input" />
          </div>
          {error && <p className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-700" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} className="btn-forest w-full disabled:opacity-60" data-testid="login-submit-button">
            {loading ? "Memproses..." : "Masuk"}
          </button>
        </div>
      </form>
    </div>
  );
}
